import { render, staticRenderFns } from "./comboboxComponent.vue?vue&type=template&id=6cbcedc8&"
import script from "./comboboxComponent.vue?vue&type=script&lang=js&"
export * from "./comboboxComponent.vue?vue&type=script&lang=js&"
import style0 from "./comboboxComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/mnt/c/Users/tes028/source/Tesfri/logistic-variant-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cbcedc8')) {
      api.createRecord('6cbcedc8', component.options)
    } else {
      api.reload('6cbcedc8', component.options)
    }
    module.hot.accept("./comboboxComponent.vue?vue&type=template&id=6cbcedc8&", function () {
      api.rerender('6cbcedc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/shared/components/generic/combobox/comboboxComponent.vue"
export default component.exports